const financeRouteFormatter = (url) => `approval-management/${url}`;

export const createDiscountRoute = () =>
  financeRouteFormatter('addOrEditDiscount');

export const viewDiscountRoute = () => financeRouteFormatter('viewdiscount');
export const createAdmissionFormFeeRoute = (schoolId) =>
  financeRouteFormatter(`admissionformfees/${schoolId}`);
export const viewAdmissionFormFeesRoute = () =>
  financeRouteFormatter(`viewformfees`);

export const getAllLeadDetailsRoute = () =>
  financeRouteFormatter(`admissiontable`);
export const getAssingedToListRoute = () =>
  financeRouteFormatter('getAssignToIdAndName');

export const getSingleLeadDetailsRoute = () =>
  financeRouteFormatter('admissionInformationOfLead');

export const updateAdmissionStatusRoute = () =>
  financeRouteFormatter('updateAddmissionStatus');

export const getViewFormRoute = () =>
  financeRouteFormatter('viewApplicationForm');

export const setupInvoicesRoute = () => financeRouteFormatter('setUpInvoice');
export const getSetupInvoicesRoute = () =>
  financeRouteFormatter('invoiceConfiguration');

export const getInvoiceTableRoute = () => financeRouteFormatter('invoiceTable');
export const getInvoiceDetailsRoute = () =>
  financeRouteFormatter('invoiceInformation');

export const getEarningDisbursedRoute = () => financeRouteFormatter('chart');

export const getReminderTimeRoute = () =>
  financeRouteFormatter('paymentReminder');

export const getParticularsRoute = () => financeRouteFormatter('particulars');

export const removeInvoicesRoute = () => financeRouteFormatter('removeInvoice');

export const acceptReferroProgramRoute = (programId) =>
  financeRouteFormatter(`referro/${programId}/approve/`);

export const rejectReferroProgramRoute = (programId) =>
  financeRouteFormatter(`referro/${programId}/reject/`);

const approvalsRouteFormatter = (url) => `buzzAppCentral/${url}`;

export const getApprovalsTableRoute = () =>
  approvalsRouteFormatter('approvals');

export const getApprovalsDiscoveryRoute = () =>
  approvalsRouteFormatter('reviews');

export const getApprovalsDiscoveryPanelRoute = () =>
  approvalsRouteFormatter('discoveryApprovals');

const adminApprovalRouteFormatter = (url) => `admin/${url}`;

export const getApprovalListRoute = () =>
  adminApprovalRouteFormatter('approvals');

export const getUserKycDetailsRoute = (userKycEntityId) =>
  `admin/approvals/${userKycEntityId}`;

export const getUserKycDocDetailsRoute = (userKycEntityId) =>
  `kyc/userKyc/${userKycEntityId}`;

export const getUserDetailsRoute = (userId) => `user/${userId}`;

export const getSchoolKycDetailsRoute = (schoolKycEntityId) =>
  `admin/approvals/${schoolKycEntityId}`;

export const getSchoolKycDocDetailsRoute = (schoolKycEntityId) =>
  `kyc/schoolKyc/${schoolKycEntityId}`;

export const kycApprovalRoute = (id) =>
  adminApprovalRouteFormatter(`approvals/${id}`);

export const commonOneApprovalRoute = (id) =>
  adminApprovalRouteFormatter(`approvals/${id}`);

export const commonApprovalRoute = (id) =>
  adminApprovalRouteFormatter(`approvals/${id}`);

export const storyDetailsRoute = (entityId) => `article/${entityId}`;

export const reviewDetailsRoute = (entityId) =>
  adminApprovalRouteFormatter(`review/${entityId}`);

export const userDetailsRoute = (userId) =>
  adminApprovalRouteFormatter(`user/${userId}`);

// approval amanagement - management

export const getManagementAppAllSchoolsRoute = () => 'bcc/school/all';
export const getInTouchForm = () => 'pwa/microsite/getintouch/';
export const getSingleBranchDetailRoute = (url) => {
  return `bcc/school/${url}`;
};

export const admissionDateRoute = (schoolId, sessionId) =>
  `school/admissionDates/${schoolId}/session/${sessionId}`;

export const academicSessionRoute = (schoolId) => `session/${schoolId}`;

export const getEditorialStoryListRoute = () => 'bcc/article';
